export enum CemexServicesEnum {
  CEMEX_PUMP = 'CNX-PUMP',
}

export enum ServicesName {
  CEMEX_PUMP = 'Cemex Pump',
}
